import { render, staticRenderFns } from "./DataHeaderBand.vue?vue&type=template&id=667144c2&"
import script from "./DataHeaderBand.vue?vue&type=script&lang=js&"
export * from "./DataHeaderBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports